import Foundation from './index';
import Projects from './Projects';
import Records from './Records';

export default {
  path: '/home/foundation',
  component: Foundation,
  redirect: '/home/foundation/projects',
  children: [
    { path: '/home/foundation/projects', component: Projects },
    { path: '/home/foundation/records/:foundationId?', component: Records }
  ]
};
